import { Amplify, Analytics } from 'aws-amplify'
import { bffURL, environment, sourceTrackingMode } from '../config'
import { newId, sendsFirehose, sendsPinpoint, track } from './sourceTracking'

const defaultEvent = {
  sdkName: 'aws-amplify',
  clientSdkVersion: '3.3.26',
  appPackageName: 'AmplifyService',
  appTitle: 'applicant-ui',
  appVersionCode: 'v1'
}

const CLIENT_ID = 'applicant-ui'

let producer = null

export default class AmplifyService {
  /**
   * Configures the transports selected by `sourceTrackingMode`: Pinpoint (legacy, kept for
   * rollback until TRDEV-33319) and/or the applicant-bff Source Tracking collector.
   */
  static initialize (identityPoolId, appId) {
    // One collector session per page load: re-initializing (e.g. route remounts) keeps the same id.
    const session = producer
      ? { sessionId: producer.sessionId, sessionStartTimestamp: producer.sessionStartTimestamp }
      : { sessionId: newId(), sessionStartTimestamp: Date.now() }
    producer = {
      environment,
      appId,
      title: defaultEvent.appTitle,
      packageName: defaultEvent.appPackageName,
      clientId: CLIENT_ID,
      ...session
    }
    if (!sendsPinpoint(sourceTrackingMode)) {
      return
    }
    const region = identityPoolId.split(':')[0]
    Amplify.configure({
      Auth: {
        identityPoolId,
        region
      },
      Analytics: {
        disabled: false,
        autoSessionRecord: false,
        AWSPinpoint: {
          appId,
          region,
          endpointId: 'applicant-ui',
          bufferSize: 1000,
          flushInterval: 5000, // 5s
          flushSize: 100,
          resendLimit: 5
        }
      }
    })
  }

  /**
   * `event` may carry `migrationEventId`, `sessionId` and `sessionStartTimestamp` so the collector
   * event keeps stable ids across remounts; those are collector-only and never sent to Pinpoint.
   */
  static sendEvent (event) {
    if (sendsPinpoint(sourceTrackingMode)) {
      const { migrationEventId, sessionId, sessionStartTimestamp, ...pinpointEvent } = event || {}
      try {
        Promise.resolve(Analytics.record({ ...defaultEvent, timestamp: new Date().toISOString(), ...pinpointEvent }))
          .catch(e => console.error('Error sending Amplify event', e))
      } catch (e) {
        console.error('Error sending Amplify event', e)
      }
    }
    if (sendsFirehose(sourceTrackingMode) && producer) {
      try {
        track(producer, bffURL, event)
      } catch (e) {
        console.error('Error sending source tracking event', e)
      }
    }
  }
}
